<template>

    <div class="timelineWrap" :class="accentClass">
        <!--In order to move the while order line, this div is positioned relative-->

        <div class="unitwrp" :key="unit.id" v-for="unit in Unit.units" :style="{ 'min-height' : unit.height + 'px'}">

            <div class="line" :style="styleProp">
                <Batch :batch="batch" v-bind:key="batch.id" v-for="batch in unit.batches" class="basket">
                </Batch>                
                <WarmingTrayTimelineBlock v-if="warmingTray" :unit="unit"></WarmingTrayTimelineBlock>
            </div>
            <div v-on:click="openCtxMnu($event,unit,Unit)" :class="{ 'gutter unitgroup unit' : 1, 'off': !unit.active}">
                <span>{{unit.nr}}</span>
                <span class="max-products" :title="'max products=' + unit.maxProducts">{{unit.maxProducts}}</span>
            </div>
        </div>

        <!--Gutter and buttons are positioned relative, to stay in the viewport-->
        <div class="gutter unitgroup">
            <!--<span class="ordernr">#{{Unit.id}}</span>-->
            <img class="unit-image" :src="webRoot + 'img/units/' + Unit.imageUrl" />
            <span class="unit-name"><span>{{Unit.name}}</span></span>
        </div>

        <!--<ctx-menu :list="cmList" @ctxMenuItemClick="onCtxClick" :underline="true" :arrow="true" :tag="2">
        </ctx-menu>-->

    </div>
</template>

<script>
    //	import timeStore from '../repositories/TimeManager';
    import Batch from '../components/Batch.vue';
    import config from '../repositories/ConfigRepository';
    import warmingTrayRepository from '../repositories/WarmingTrayRepository';
    import WarmingTrayTimelineBlock from '../components/WarmingTrayTimelineBlock.vue';
    import ctxMenu from '../components/CtxMenu.vue';
    import Vue from 'vue';
    import warmingTrayOverlay from '../components/WarmingTraysOverlay';
    // Import the EventBus
    import { EventBus } from '../repositories/Eventbus';

    const Unit = {

        props: {
            Zoom: { type: Number, default: 100 },
            Unit: { type: Object },
            Left: { type: Number, default: 0 },
            AccentColor: { type: Number },
            styleProp: { type: Object }

        },
        components: { Batch, ctxMenu, WarmingTrayTimelineBlock },

        data: function () {
            return {
                OrderLeft: 0, xPosition: 0, webRoot: config.endPointUrl, timer: null, Waitforkey: false, warmingTrays : warmingTrayRepository.warmingTrays

                //cmList: [{
                //	text: 'Play Now',
                //	icon: 'iconfont icon-bofang'
                //}, {
                //	text: 'Play Next',
                //	icon: 'iconfont icon-xiayishou'
                //}, {
                //	text: 'More',
                //	children: [{
                //		text: 'Download',
                //		children: []
                //	}, {
                //		text: 'Report'
                //	}, {
                //		text: 'Other',
                //		icon: 'iconfont icon-bofang',
                //		children: [{
                //			text: 'Other-1'
                //		}, {
                //			text: 'Other-2'
                //		}, {
                //			text: 'Other-3'
                //		}]
                //	}]
                //}]

            };
        },

        methods: {
            openCtxMnu: function ($event, unit, unitGroup) {
                
                if (unitGroup.isWarmingTray) {
                    // create orderDetail vue compnent
                    // https://css-tricks.com/creating-vue-js-component-instances-programmatically/
                    var ComponentClass = Vue.extend(warmingTrayOverlay)
                    // set properties
                    var component = new ComponentClass(
                        {
                            propsData: {}// { warmingTrays : this.warmingTrays  }
                        }
                    );
                    component.$mount();

                    // https://sweetalert2.github.io/#configuration
                    this.$fire({
                        //title: "Bestelling #" + this.Order.orderNr,
                        html: '', // _orderDetail.$el.outerHTML,
                        width: '50rem',
                        padding: '0px',
                        showConfirmButton: false,
                        position: 'top',
                        customClass: {
                            container: 'order-detail'
                        },
                        onOpen: function (ell) {
                            ell.children[1].appendChild(component.$el);
                        }
                    }).then(() => {
                        component.$destroy();
                    });
                } else {
                    Vue.prototype.$easycm($event, this.$root, unit.active ? 'unit-active' : 'unit-inactive', unit);
                }               

            },
            calculateBatches:  function (retrycount, force) {

                var _this = this;
                if (_this._bussy) {
                    return;
                }

                if (this.timer != null) {
                    window.clearTimeout(this.timer);
                }

                this.timer = window.setTimeout(async function () {
                    _this._bussy = true;
                    try {
                        if (force || _this.Waitforkey) {
                            await _calculate_method_debug();
                        }
                        else {
                            if (!_calculate_method3()) {

                                // dom not ready
                                if (typeof retrycount == "undefined") {
                                    retrycount = 0;
                                }
                                // loop detection
                                if (retrycount < 20) {
                                    // dom not ready, retry;
                                    retrycount++;
                                    
                                    _this.calculateBatches(retrycount);
                                    _this._bussy = false;
                                }
                            }
                            _this._bussy = false;
                        }
                    } catch (e) {
                        window.console.log(e);
                    }

                   
                   
                }, 300);

                /*
                function _calculate() {

                    //console.log("start calculate"); // true
                    // calculate the y position if overlapped.
                    _this.Unit.units.forEach(function (unit) {

                        var stack = 0;
                        var maxStack = 0;
                        var endtimes = [];
                        var stackcount = 0;

                        if (unit.batches.length) {
                            unit.batches.forEach(function (batch) {
                                batch.stack = 0;
                                endtimes.push(batch);
                            });

                            // sorted indexes.
                            endtimes = endtimes.sort(function (a, b) { return a.scrollRight - b.scrollRight });

                            for (var keysource = 0; keysource < endtimes.length - 1; keysource++) {

                                keysource = parseInt(keysource);
                                let sourceBatch = endtimes[keysource];
                                let targetBatch = endtimes[keysource + 1];

                                if (stackcount++ < 10 && sourceBatch.products.length && targetBatch.products.length && sourceBatch.domCalculated && (targetBatch.scrollLeft < sourceBatch.scrollRight - 5)) {
                                    stack = (sourceBatch.stack) + sourceBatch.products.length;
                                    maxStack = stack + targetBatch.products.length > maxStack ? stack + targetBatch.products.length : maxStack;
                                } else {
                                    // no collision
                                    stack = 0;
                                    stackcount = 0;
                                }

                                Vue.set(targetBatch, 'stack', stack);
                            }

                            unit.height = maxStack * 30 + 10;
                        } else {
                            unit.height = 3 * 30;
                        }


                        //unit.height = maxStack * 30 + 10;
                    });

                    _this.timer = null;

                    Vue.nextTick(function () {
                        console.log("updated"); // true
                    })
                }


                function _calculate_method2() {

                    // console.log("start calculate"); // true
                    // calculate the y position if overlapped.
                    _this.Unit.units.forEach(function (unit) {

                        var stack = 0;
                        var maxStack = 0;
                        var endtimes = [];

                        unit.batches.forEach(function (batch) {
                            if (batch.domCalculated) {
                                batch.stack = 0;
                                endtimes.push(batch);
                            } else {
                                return false;

                                // console.log('dom not calculated!');
                            }
                        });

                        // sorted indexes.
                        endtimes = endtimes.sort(function (a, b) { return a.scrollRight - b.scrollRight });

                        for (var keysource in endtimes) {
                            keysource = parseInt(keysource);
                            let sourceBatch = endtimes[keysource];

                            maxStack = sourceBatch.products.length > maxStack ? sourceBatch.products.length : maxStack;

                            if (sourceBatch.products.length) {
                                for (var keyTarget = keysource + 1; keyTarget < endtimes.length; keyTarget++) {
                                //for (var keyTarget = keysource - 1; keyTarget >= 0; keyTarget--) {

                                    let targetBatch = endtimes[keyTarget];
                                    maxStack = targetBatch.stack + targetBatch.products.length > maxStack ? targetBatch.stack + targetBatch.products.length : maxStack;

                                    //if (sourceBatch.id == 16290 && targetBatch.id == 16305) {
                                    //    console.log('test');
                                    //}

                                    // find overlap.
                                    if (targetBatch.scrollLeft < sourceBatch.scrollRight - 2) {
                                        //if ((targetBatch.stack + targetBatch.products.length) > sourceBatch.stack) {
                                        if ((targetBatch.stack + targetBatch.products.length >= sourceBatch.stack )
                                            && targetBatch.stack <= (sourceBatch.stack + sourceBatch.products.length)) {
                                             stack = (sourceBatch.stack) + sourceBatch.products.length;
                                             if (stack > targetBatch.stack) {
                                                 Vue.set(targetBatch, 'stack', stack);
                                             }
                                            maxStack = targetBatch.stack + targetBatch.products.length > maxStack ? targetBatch.stack + targetBatch.products.length : maxStack;
                                        }
                                    }
                                }
                            }
                        }
                        unit.height = maxStack * 36;

                        // cleanup
                        // endtimes = [];
                    });

                    _this.timer = null;

                    Vue.nextTick(function () {
                        //console.log("updated"); // true
                    })

                    return true;
                }
                */

                function _calculate_method3() {

                    var domready = true;

                    _this.$el.querySelectorAll(".batch").forEach(a => a.style.top = '0px');

                    // console.log("start calculate"); // true
                    // calculate the y position if overlapped.
                    _this.Unit.units.forEach(function (unit) {

                        var stack = 0;
                        var maxStack = 0;
                        var endtimes = [];
                        var backtrackloopdetection = 0;

                        unit.batches.forEach(function (batch) {
                            if (batch.domCalculated) {
                                batch.stack = 0;
                                if (batch.products.length) {
                                    endtimes.push(batch);
                                }
                            } else {
                                domready = false;

                                window.console.log('dom not calculated!');
                            }
                        });

                        if (!domready) {
                            return false;
                        }

                        // sorted indexes.
                        endtimes = endtimes.sort(function (a, b) { return a.endTime - b.endTime });
                        var searchFrom = 0;
                        var searchFromPrev = 0;
                        

                          // loop through all batches in this unit, sorted by endtime
                        for (var keysource in endtimes) {

                            keysource = parseInt(keysource);
                            let sourceBatch = endtimes[keysource];

                            maxStack = sourceBatch.products.length > maxStack ? sourceBatch.products.length : maxStack;
                                                     
                            let collision = false;
                            backtrackloopdetection = 0;

                            for (var keyTarget = searchFrom; keyTarget < keysource; keyTarget++) {
                                  
                                let targetBatch = endtimes[keyTarget];
                                                                        

                                // find overlap.
                                if (targetBatch.scrollRight > sourceBatch.scrollLeft) {
                                    //if ((targetBatch.stack + targetBatch.products.length) > sourceBatch.stack) {
                                    if ((targetBatch.stack + targetBatch.products.length >= sourceBatch.stack)
                                        && targetBatch.stack < (sourceBatch.stack + sourceBatch.products.length)) {

                                        collision = true;

                                     
                                        // todo, track all colletions with this one, to detect overlap!
                                        stack = (targetBatch.stack) + targetBatch.products.length;
                                        if (stack > sourceBatch.stack) {

                                            // loop again, until there is no collision left.
                                            if (backtrackloopdetection++ < 100) {
                                                keyTarget = searchFrom;
                                            }                                            

                                            Vue.set(sourceBatch, 'stack', stack);

                                            let $el = _this.$el.querySelector(".batch.id-" + sourceBatch.id);
                                            if ($el) {
                                                $el.style.top = (stack * 32) + 'px';
                                            }
                                        }

                                        maxStack = sourceBatch.stack + sourceBatch.products.length > maxStack ? sourceBatch.stack + sourceBatch.products.length : maxStack;
                                    }
                                }

                                maxStack = targetBatch.stack + targetBatch.products.length > maxStack ? targetBatch.stack + targetBatch.products.length : maxStack;

                            }
                            if (!collision) {
                                //  performance, only look back from the last collision
                                if (keysource > 5) {
                                    searchFrom = searchFromPrev;
                                    searchFromPrev = keysource;
                                }
                            }
                            
                        }
                        unit.height = maxStack * 36;

                        // cleanup
                        // endtimes = [];
                    });

                    _this.timer = null;

                    Vue.nextTick(function () {
                        //console.log("updated"); // true
                    })
                    return domready;

                }

                async function _calculate_method_debug() {

                    var domready = true;

                    // testing.
                    window.console.log("start calculate1 " + new Date().getMilliseconds()); // true
                    _this.$el.querySelectorAll(".batch").forEach(a => a.style.top = '0px');

                    // calculate the y position if overlapped.
                    _this.Unit.units.forEach(async function (unit) {
                        try {

                            function waitingKeypress() {
                                return new Promise((resolve) => {
                                    document.addEventListener('keydown', onKeyHandler);
                                    function onKeyHandler(e) {
                                        document.removeEventListener('keydown', onKeyHandler);
                                        resolve();
                                        e.preventDefault = true;
                                        e.cancelBubble = true;

                                    }
                                });
                            }

                            var stack = 0;
                            var maxStack = 0;
                            var endtimes = [];

                            unit.batches.forEach(function (batch) {
                                if (batch.domCalculated) {
                                    batch.stack = 0;
                                    if (batch.products.length) {
                                        endtimes.push(batch);
                                    }
                                } else {
                                    domready = false;
                                    window.console.log('dom not calculated!');
                                }
                            });

                            if (!domready) {
                                return false;
                            }

                            // sorted indexes.
                            endtimes = endtimes.sort(function (a, b) { return a.endTime - b.endTime });
                                                    
                            var searchFrom = 0;
                            var searchFromPrev = 0;

                            // loop through all batches in this unit, sorted by endtime
                            for (var keysource in endtimes) {

                                keysource = parseInt(keysource);
                                let sourceBatch = endtimes[keysource];

                                // set max stack, calculate unit height
                                maxStack = sourceBatch.products.length > maxStack ? sourceBatch.products.length : maxStack;

                                let collision = false;

                                document.querySelector(".batch.id-" + sourceBatch.id).style["border"] = "solid 1px green";

                                // loop through the batches begining from this batch to the end.
                                for (var keyTarget = searchFrom; keyTarget < keysource; keyTarget++) {

                                    let targetBatch = endtimes[keyTarget];

                                    document.querySelector(".batch.id-" + targetBatch.id).style["border"] = "solid 1px red";

                                    //if (sourceBatch.id == 17668 && targetBatch.id == 17639) {
                                    //    console.log('test');
                                    //}

                                    // find overlap.
                                    if (targetBatch.scrollRight > sourceBatch.scrollLeft ) {
                                        //if ((targetBatch.stack + targetBatch.products.length) > sourceBatch.stack) {
                                        if ((targetBatch.stack + targetBatch.products.length >= sourceBatch.stack)
                                            && targetBatch.stack < (sourceBatch.stack + sourceBatch.products.length)) {

                                            collision = true;

                                            // todo, track all colletions with this one again, to detect overlap!
                                          
                                            stack = (targetBatch.stack) + targetBatch.products.length;
                                            if (stack > sourceBatch.stack) {
                                                // loop again, until there is no collision left.
                                                keyTarget = searchFrom;

                                                Vue.set(sourceBatch, 'stack', stack);

                                                let $el = _this.$el.querySelector(".batch.id-" + sourceBatch.id);
                                                if ($el) {
                                                    $el.style.top = (stack * 30) + 'px';
                                                }

                                            }
                                            maxStack = sourceBatch.stack + sourceBatch.products.length > maxStack ? sourceBatch.stack + sourceBatch.products.length : maxStack;
                                        }
                                    }

                                  

                                    await waitingKeypress();

                                    document.querySelector(".batch.id-" + targetBatch.id).style["border"] = "";

                                    maxStack = targetBatch.stack + targetBatch.products.length > maxStack ? targetBatch.stack + targetBatch.products.length : maxStack;
                                }

                                if (!collision) {
                                    // performance, only look back from the last collision
                                    if (keysource > 5) {
                                        searchFrom = searchFromPrev;
                                        searchFromPrev = keysource;
                                    }
                                }

                                document.querySelector(".batch.id-" + sourceBatch.id).style["border"] = "";


                            }
                            unit.height = maxStack * 36;
                        } catch (e) {
                            window.console.log(e);
                        }
                        // cleanup
                        // endtimes = [];
                    });

                    window.console.log('bathces calculated')
                    _this.timer = null;

                    Vue.nextTick(function () {
                        //console.log("updated"); // true
                    })
                    return domready;

                }
            }


        },

        computed: {

            accentClass: function () {
                var className = {};
                className['accent' + this.AccentColor] = 1;
                className['is-delivery'] = this.Unit.isDeliveryUnit;
                className['is-warmingtray'] = (this.warmingTray != null);
                return className;
            },
           
            warmingTray: function () {
                return this.warmingTrays.find(a => a.active && a.id == this.Unit.id);
            }
        },

        watch: {

            //"Order.orderDate": function (newValue, oldValue) {
            //	var _this = this;

            //	_this.xPosition = function () {

            //		let startDate = _this.StartDate.getTime();
            //		let endDate = _this.EndDate.getTime();
            //		let TotalMiliseconds = endDate - startDate;
            //		return (((_this.Order.orderDate.getTime() - startDate) / TotalMiliseconds) * 100);

            //	}();
            //}
        },

        created: function () {



        },
        updated: function () {
            this.$nextTick(function () {
                // Code that will run only after the
                // entire view has been re-rendered
                this.calculateBatches();
            })
        },
        mounted: function () {
            var _this = this;

            EventBus.$on('batches-changed', function () {
                _this.calculateBatches()
            });

            this.calculateBatches();

            // quick fix, for the sometimes ocuring overlap.
            window.setInterval(_this.calculateBatches, 60000);

            document.addEventListener('keydown', function (e) {
                if (e.key == "w") {
                    // enter pressed, waitforkey
                     window.console.log('waitforkey = true');
                    _this.Waitforkey = !_this.Waitforkey;
                    _this.calculateBatches(0, true);
                }
            });


            // var _this = this;

            //// todo: use draggable here and in the timeline.
            //var draggable = new Draggable(_this.$el, {
            //	'draggable': '.order',

            //	mirror: {
            //		constrainDimensions: true,
            //		//cursorOffsetX: 10,
            //		//cursorOffsetY: 10,
            //		yAxis: false
            //	}

            //});
            //var newX, start;

            //draggable.on('drag:start', e => {
            //	start = e.sensorEvent.clientX;
            //	console.log(start);
            //});

            //draggable.on('drag:move', e => {
            //	var end = e.sensorEvent.clientX;
            //	newX = end;
            //	console.log(e.mirror);
            //});

            //draggable.on('drag:stop', (a, b) => {
            //	var moved = start - newX;// a.source.offsetLeft;

            //	// newx= px, calculate percentage (position is based on percentage)
            //	var width = this.$el.querySelector('.line').offsetWidth;
            //	var percentage = (moved / width) *100

            //	let startDate = _this.StartDate.getTime();
            //	let endDate = _this.EndDate.getTime();
            //	let TotalMiliseconds = endDate - startDate;

            //	let newdate = startDate + (percentage / 100) * TotalMiliseconds;
            //	var date = new Date(newdate);

            //	unitRepository.setStartDate(_this.Order, date);

            //});




            //// todo : combine this logic with drag-drop in timeline.vue
            //this.xPosition = timeStore.calculateXPosition(new Date());

            //function onMouseDown(e) {

            //	var start = e.clientX || e.touches[0].clientX;

            //	var width = _this.$el.querySelector('.line').offsetWidth;


            //	if (e.touches) {
            //		document.body.ontouchmove = function (e) {

            //			var end = e.touches[0].clientX;
            //			_this.xPosition += (end - start) / width * 100;
            //			start = end;
            //		};

            //		document.body.ontouchend = function () {
            //			document.body.ontouchmove = document.body.ontouchend = null;
            //			onDragEnd();
            //		};
            //	}
            //	else {
            //		document.body.onmousemove = function (e) {
            //			var end = e.clientX;
            //			_this.xPosition += (end - start) / width * 100;
            //			start = end;


            //		};

            //		document.body.onmouseup = function () {
            //			document.body.onmousemove = document.body.onmouseup = null;
            //			onDragEnd();
            //		};
            //	}

            //	function onDragEnd() {
            //		// calculate position to time


            //		//let startDate = _this.StartDate.getTime();
            //		//let endDate = _this.EndDate.getTime();
            //		//let TotalMiliseconds = endDate - startDate;

            //		//let newdate = startDate + (_this.xPosition / 100) * TotalMiliseconds;
            //		//var date = new Date(newdate);

            //		//unitRepository.setStartDate(_this.Order, date);
            //	}


            //	e.stopPropagation();
            //}

            //this.$el.querySelector('.order').onmousedown = onMouseDown;
            //this.$el.querySelector('.order').ontouchstart = onMouseDown;
        },


    };

    export { Unit as default };

</script>
